import { webServerHostUrl } from '../../utilities/url_util';
import { profileMetaTagString } from '../../utilities/meta_tags_util';
import { getProfileDescription } from '../../apis/metaData';
import { checkImgType } from '../../utilities/image_util';
import { getLanguageByRank } from '../../utilities/language';

const getSecretId = () => process.env.SECRET_ID_FOR_META_TAGS;
async function loadData(urlPath, language, query, params, headers) {
  let metaData = '';
  if (!params.userid) {
    return {
      metaData: null,
    };
  }

  if (params.userid === 'apple-app-site-association') {
    return {
      metaData: null,
    };
  }

  const userid = params.userid;

  try {
    const metaDataResult = await getProfileDescription(userid, getSecretId());
    if (metaDataResult.data.status !== '200') {
      return {
        notFound: true,
      };
    }
    const {
      nickname,
      description,
      cover,
      noindex,
      type,
      language: authorLanguage,
    } = metaDataResult.data.results;
    const metaLanguage = getLanguageByRank(
      query.hl,
      authorLanguage,
      headers['accept-language'],
    );
    const image = checkImgType({ data: cover, isSSR: true, widthLimit: 800 });
    const metaString = profileMetaTagString({
      urlPath,
      title: nickname,
      image,
      description,
      language: metaLanguage,
      nickname,
      noindex,
      type,
    });
    const htmlLang = authorLanguage || 'en';
    const realUserid = metaDataResult.data.results.userid;

    metaData += metaString;

    if (userid === realUserid) {
      return {
        metaData,
        htmlLang,
      };
    }
    return {
      redirect: {
        status: 301,
        url: `${webServerHostUrl()}${realUserid}`,
      },
    };
  } catch (error) {
    return {
      metaData: null,
    };
  }
}

export default loadData;
